import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@cimpress/react-components/lib/Accordion';
import Button from '@cimpress/react-components/lib/Button';
import { withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import { Link } from 'react-router-dom';
import { css } from 'react-emotion';
import { connect } from 'react-redux';
import { SkuSelector } from '@cimpress-technology/ff-react-components';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { auth } from '../../utils/auth';
import StepTitle from '../common/StepTitle';
import TermLink from '../common/TermLink';
import WizardNavigator from '../common/WizardNavigator';
import { updateSkus, resetSkus } from '../../reducers/termselect/actions';

const sectionsStyle = css({
  padding: '0 20px'
});

const termStyle = css({
  padding: '10px 0px'
});

class SkuSelectStep extends PureComponent {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    sellerId: PropTypes.string.isRequired,
    selectedSkus: PropTypes.objectOf(PropTypes.any).isRequired,
    selectedTerms: PropTypes.objectOf(PropTypes.any).isRequired
  };

  onPrev = () => {
    const { resetSkus } = this.props;
    resetSkus();
  };

  onNext = () => {
    const { wizard, onUpdate } = this.props;
    wizard.setStep(wizard.next);
    onUpdate && onUpdate();
  };

  onAddSku = skuInfo => {
    const { updateSkus, selectedSkus } = this.props;
    updateSkus({ ...selectedSkus, [skuInfo.sku]: skuInfo });
  };

  onBulkAddSkus = skusToAdd => {
    const { updateSkus, selectedSkus } = this.props;
    updateSkus({ ...selectedSkus, ...skusToAdd });
  };

  onBulkRemoveSkus = skusToRemove => {
    const { updateSkus, selectedSkus } = this.props;
    const newSkus = omit(selectedSkus, skusToRemove);
    updateSkus(newSkus);
  };

  onRemoveSku = skuInfo => {
    const { updateSkus, selectedSkus } = this.props;
    const updatedSkus = omit(selectedSkus, skuInfo.sku);
    updateSkus(updatedSkus);
  };

  render() {
    const { selectedSkus, sellerId, selectedTerms } = this.props;
    const skuList = Object.keys(selectedSkus);
    const skuCount = skuList ? skuList.length : 0;
    return (
      <div>
        <StepTitle
          icon="t-shirt-l"
          title="Select products to add to your contracts"
          description="Select products from the product catalog, or reuse products that were added recently to other contracts. Rules and constraints defined in these contracts will apply to all selected products."
        />
        <div className={sectionsStyle}>
          <Accordion title="Selected Contracts">
            {map(selectedTerms, term => <TermLink key={term && term.termId} className={termStyle} term={term} />)}
          </Accordion>
        </div>
        <div className={sectionsStyle}>
          <SkuSelector
            addNonExistentSkus
            locale="en"
            skipLoadDescriptionsForBulkAddSkus={true}
            skuSearchSectionTitle="Search and Select Products"
            skuBinSectionTitle="Products to Add"
            selectedSkus={selectedSkus}
            onAddSku={this.onAddSku}
            onRemoveSku={this.onRemoveSku}
            onBulkAddSkus={this.onBulkAddSkus}
            onBulkRemoveSkus={this.onBulkRemoveSkus}
            sellerFulfillerId={sellerId}
            // we need this props in order to allow bulk removals
            unremoveableSkuList={[]}
            onGetAccessToken={auth.getAccessToken}
            marketable={false}
          />
        </div>
        <WizardNavigator
          onPrev={this.onPrev}
          onNext={this.onNext}
          customPrev={
            <Link to="/">
              <Button type="link" onClick={this.onPrev}>
                Cancel
              </Button>
            </Link>
          }
          customNext={
            <Button
              className="btn btn-primary"
              disabled={isEmpty(selectedSkus)}
              disabledTooltipContents={'You must select products to add to your contract'}
              onClick={this.onNext}>
              {`Add ${skuCount > 0 ? skuCount : ''} SKUs`}
            </Button>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedSkus: state.termSelectReducer.selectedSkus,
  selectedTerms: state.termSelectReducer.selectedTerms,
  sellerId: state.termSelectReducer.sellerId
});

const mapDispatchToProps = dispatch => ({
  updateSkus: skus => dispatch(updateSkus(skus)),
  resetSkus: () => dispatch(resetSkus())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withWizard(SkuSelectStep));
